// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "support/static/css/" + chunkId + "." + "31e5a9775920877729d5" + ".css";
};